import http from 'utils/http';
import { getOrganizationsUrl, getUpdateOrganizationsUrl } from './apiUrl';
import { OrganizationsResponse } from './types';

export function getOrganizations(): Promise<OrganizationsResponse> {
  return http.get(getOrganizationsUrl());
}

export function updateOrganizations(payload: OrganizationsResponse | FormData): Promise<OrganizationsResponse> {
  return http.put(getUpdateOrganizationsUrl(), payload);
}
